// Generic formatting helpers reused from V1 (these are not V1-shape-specific).
// Re-exported here so the V2 section stays self-contained.
export { formatNum, formatPct, humanizeKey } from "../assistant/utils";

/**
 * Format a finite number for display: whole numbers print as-is, everything
 * else is rounded to a fixed 2 decimal places.
 */
export function formatNumber(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
}

/** Render a JSON-safe frame cell for display. */
export function formatCell(cell: unknown): string {
  if (cell === null || cell === undefined) return "—";
  if (typeof cell === "number") {
    if (!Number.isFinite(cell)) return "—";
    return formatNumber(cell);
  }
  if (typeof cell === "boolean") return cell ? "true" : "false";
  return String(cell);
}

/** True for numeric-ish cells so a column can be right-aligned / tabular. */
export function isNumericCell(cell: unknown): boolean {
  return typeof cell === "number" && Number.isFinite(cell);
}

/** Format a scalar answer value (number or string). */
export function formatScalarValue(value: number | string): string {
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return "—";
    return formatNumber(value);
  }
  return value;
}
